export const ProgramRequestOfferDivide = (): JSX.Element => (
  <div className="md:mt-[1.8vw] border-b border-[#999999]" />
)
